import RecruitApiClient from '../../RecruitApiClient';
import { IPreviewData } from '../Application/types';

class Api {
  getExternalViewData = (
    jobId: number,
    applicationId: number,
    externalViewId: string,
    loginHash: string
  ): Promise<{ res: any }> =>
    RecruitApiClient.get(
      `/api/v4/jobs/${jobId}/applications/${applicationId}/application_external_view/${externalViewId}`,
      { login_hash: loginHash }
    );

  previewAttachment = (
    jobId: number,
    applicationId: number,
    externalViewId: string,
    loginHash: string,
    assetId: number,
    index: number
  ): Promise<{ res: IPreviewData }> =>
    RecruitApiClient.get(
      `/api/v4/jobs/${jobId}/applications/${applicationId}/application_external_view/${externalViewId}/assets/${assetId}/preview`,
      { login_hash: loginHash, index: index }
    );
}

export default new Api();
